import SessionsPage from "./SessionsPage";

export const routes = [{ path: "sessions", element: <SessionsPage /> }];
